import { useCallback, useMemo } from 'react';
import { createEditor, Editor } from 'slate';
import { withHistory } from 'slate-history';
import { withReact } from 'slate-react';

import { CreateAttachmentApiArg, filesApi } from 'apis/files';
import { useNotifications } from 'hooks/useNotifications';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { withImages } from '../utils/image';
import { withLinks } from '../utils/link';

/** Hook to create and memoize as instance of the slate editor */
export function useEditor(): Editor {
  const dispatch = useAppDispatch();

  const uploadFile = useCallback(
    (payload: CreateAttachmentApiArg) => {
      return dispatch(
        filesApi.endpoints.createAttachment.initiate(payload),
      ).unwrap();
    },
    [dispatch],
  );

  const notify = useNotifications();
  const notifyError = useCallback(
    (message: string) => notify({ title: message, type: 'error' }),
    [notify],
  );

  const editor = useMemo(
    () =>
      withImages(
        uploadFile,
        notifyError,
      )(withLinks(withHistory(withReact(createEditor())))),
    // don't want to recreate editor if uploadFile changes, so leaving it out of deps
    [], // eslint-disable-line react-hooks/exhaustive-deps
  );

  return editor;
}
